var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharbon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.73 85.5149L194.97 84.5349L228.05 115.955L230.23 156.045L224.11 166.675L221.48 122.185L182.73 85.5149Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.05 183.875L218.25 189.535L224.11 166.675L230.23 156.045V168.155",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.1 73.3248L174.49 72.7048L194.98 84.5348L182.74 85.5148L171.58 79.1148L162.11 73.3448H162.1V73.3248Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.83 138.585L224.1 166.665L218.24 189.525L185.62 195.515L188.83 138.585Z",
    fill: "#B2E8C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.1 73.3242L182.73 85.4942L198.64 144.234L125.1 104.614L162.09 73.3142H162.1V73.3242Z",
    fill: "#B2E8C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.73 85.5144L221.48 122.184L224.11 166.674L188.84 138.594L182.74 85.5144H182.73Z",
    fill: "#72D09A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.63 195.525L129.8 161.095L125.73 131.445L125.11 104.635L188.84 138.595L185.63 195.525Z",
    fill: "#72D09A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4102 77.0245L106.18 76.3845L135.83 112.905L148.17 158.825L139.77 165.545L116.83 104.885L94.4102 77.0345V77.0245Z",
    fill: "#72D09A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.38 187.904L122.98 192.754L139.78 165.534L148.18 158.814L143.98 170.914",
    fill: "#B2E8C5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4602 56.0143L69.8402 55.3943L90.3302 67.2243L106.19 76.3843L94.4202 77.0243L66.3701 61.0843L57.4602 56.0143Z",
    fill: "#B2E8C5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1902 110.324L139.78 165.534L122.98 192.754L80.9901 178.204L64.1802 110.314H64.1902V110.324Z",
    fill: "#72D09A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4502 56.0144L94.4102 77.0244L64.1802 110.324L28.9702 86.7644L57.4502 56.0244V56.0144Z",
    fill: "#72D09A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4102 77.0242L116.83 104.874L139.77 165.534L64.1902 110.324L94.4202 77.0242H94.4102Z",
    fill: "#B2E8C5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9902 178.204L25.1603 143.774L21.0903 114.124L28.9703 86.7644L64.1903 110.324L81.0002 178.214H80.9902V178.204Z",
    fill: "#B2E8C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharbon);
export default __webpack_public_path__ + "static/media/charbon.c53ac043d5c90c1132162940ae0cdb62.svg";
export { ForwardRef as ReactComponent };